import { Icons, Images } from "@assets/assets";

interface ServiceItem {
  icon?: any;
  title?: string;
  description?: string;
  link?: string;
  icondark?: any;
}

export const services: ServiceItem[] = [
  {
    icon: Icons?.ourServicesIcons?.AI_Development_Implementation,
    icondark: Images?.cardicon4,
    title: "AI Development and Implementation",
    description:
      "As a leading AI development company, we deliver intelligent digital solutions to streamline business operations and scale effortlessly.",
    link: "/ai-development-company",
  },
  {
    icon: Icons?.ourServicesIcons?.AI_Agent_Development,
    icondark: Images?.cardicon3,
    title: "AI Agent Development ",
    description:
      "We build intelligent AI-powered agents that automate workflows to enhance efficiency, visitor interactions, and streamline operations.",
    link: "/ai-agent-development-services",
  },
  {
    icon: Icons?.ourServicesIcons?.Mobile_App_Development,
    icondark: Images?.cardicon1,
    title: "Mobile App Development",
    description:
      "Turn your mobile app ideas into custom AI-powered mobile app solutions that bring long term business value with real results.",
    link: "/mobile-application-development",
  },
  {
    icon: Icons?.ourServicesIcons?.Web_App_Development,
    icondark: Images?.cardicon2,
    title: "Web App Development",
    description:
      "Our web app developers create smooth and responsive web applications that deliver native-app like user experience.",
    link: "/web-development",
  },
];
